import { type EvalBidDto } from "../../../../autogen/bff-api";

/** The rank-1 bid is the default winner suggestion in the award step. Returns undefined when there are no bids. */
export const pickDefaultWinner = (bids: EvalBidDto[]): string | undefined =>
  [...bids].sort((a, b) => a.rank - b.rank)[0]?.bidId;
